<span [matTooltip]="tooltip" [matTooltipDisabled]="tooltipDisabled || !tooltip.trim()">
  <button mat-icon-button
          [disabled]="disabled"
          [attr.aria-label]="ariaLabel?.trim() ? ariaLabel : (tooltip.trim() ? tooltip : null)"
          (click)="triggerAction()">
    <mat-icon class="material-symbols-outlined mat-symbols-rounded">{{ icon }}</mat-icon>
  </button>
</span>
